import { useQuery } from "@tanstack/react-query";
import { Table, Spin } from "antd";
import { ColumnsType } from "antd/es/table";
import { useAtomValue } from "jotai";
import PageLayout from "../../../layouts/pageLayout/pageLayout";
import styles from "../dashboardPage.module.scss";
import { userAtom } from "../../../utils/store";
import { getJambByApplicantId } from "../../../utils/request";

interface UtmeTableRow {
  id: number | string;
  examNumber: string;
  examYear: string;
  totalScore: number;
  resultUrl: string;
  subjects: JambResultSubject[];
}

const UtmeResult = () => {
  const user = useAtomValue(userAtom);

  const { data, isLoading } = useQuery({
    queryKey: ["get-utme-result", user?.applicantId],
    queryFn: () => getJambByApplicantId(user?.applicantId ?? ""),
    enabled: !!user?.applicantId,
  });

  const jambData = data?.data as JambResultData | undefined;

  const tableData: UtmeTableRow[] = jambData?.examNumber
    ? [
        {
          id: jambData.id ?? jambData.applicantId,
          examNumber: jambData.examNumber,
          examYear: jambData.examYear,
          totalScore: jambData.totalScore,
          resultUrl: jambData.jambResultUrl || jambData.jambResult || "",
          subjects: jambData.subjects || [],
        },
      ]
    : [];

  const columns: ColumnsType<UtmeTableRow> = [
    {
      title: "S/N",
      key: "serialNumber",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Exam Number",
      dataIndex: "examNumber",
      key: "examNumber",
    },
    {
      title: "Exam Year",
      dataIndex: "examYear",
      key: "examYear",
    },
    {
      title: "Total Score",
      dataIndex: "totalScore",
      key: "totalScore",
    },
    {
      title: "Subjects",
      dataIndex: "subjects",
      key: "subjects",
      render: (subjects: JambResultSubject[]) =>
        subjects?.length
          ? subjects
              .map(
                (subject) =>
                  `${subject.subjectName?.trim()}: ${subject.score}`,
              )
              .join(", ")
          : "N/A",
    },
    {
      title: "Result",
      dataIndex: "resultUrl",
      key: "resultUrl",
      render: (value: string) =>
        value ? (
          <a href={value} target="_blank" rel="noopener noreferrer">
            View Result
          </a>
        ) : (
          "N/A"
        ),
    },
  ];

  if (isLoading) {
    return <Spin size="large" />;
  }

  return (
    <PageLayout heading="UTME Result">
      <Table
        columns={columns}
        dataSource={tableData}
        className={styles.row}
        rowKey="id"
        scroll={{ x: 400 }}
        pagination={false}
      />
    </PageLayout>
  );
};

export default UtmeResult;
